var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-custom-lang-select", {
                    model: {
                      value: _vm.selectedLang,
                      callback: function ($$v) {
                        _vm.selectedLang = $$v
                      },
                      expression: "selectedLang",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._t("default"),
        ],
        2
      ),
      _c(
        "w-sortable",
        {
          attrs: {
            items: _vm.line,
            "disable-x": "",
            "keep-in-y": "",
            tag: "w-list",
            "target-class": "handle",
          },
        },
        _vm._l(_vm.line, function (prop, i) {
          return _c(
            "w-list-item",
            { key: i, attrs: { "show-handle": "" } },
            [
              _c("w-list-item-text", [
                _c("span", { attrs: { "style-off": prop.Style.getStyle() } }, [
                  _vm._v(
                    " " + _vm._s(prop.Text.getTranslation(_vm.selectedLang))
                  ),
                  _c("span", { staticClass: "field" }, [
                    _vm._v(_vm._s(_vm.getPropValue(prop))),
                  ]),
                  _vm._v(
                    _vm._s(prop.TextAfter.getTranslation(_vm.selectedLang)) +
                      " "
                  ),
                ]),
              ]),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct(`tooltip.line-edit`),
                          expression: "$ct(`tooltip.line-edit`)",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.editProp(prop)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "pen" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct(`tooltip.style-edit`),
                          expression: "$ct(`tooltip.style-edit`)",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.editStyle(prop)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "font" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct(`tooltip.line-remove`),
                          expression: "$ct(`tooltip.line-remove`)",
                        },
                      ],
                      staticClass: "danger",
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.removeItem(i)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "trash" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct(`tooltip.line-add`),
                  expression: "$ct(`tooltip.line-add`)",
                },
              ],
              attrs: { flat: "" },
              on: {
                click: function ($event) {
                  return _vm.addItemClicked()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "plus" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditStyleProp != null } },
        [
          _vm.toEditStyleProp
            ? _c("app-style-editor", {
                attrs: { value: _vm.toEditStyleProp.Style },
                on: {
                  input: function ($event) {
                    _vm.toEditStyleProp.Style = $event
                  },
                  close: function ($event) {
                    _vm.toEditStyleProp = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditProp != null } },
        [
          _vm.toEditProp
            ? _c(
                "app-field-edit",
                {
                  attrs: {
                    value: _vm.toEditProp,
                    "selected-lang": _vm.selectedLang,
                  },
                  on: {
                    "update:selectedLang": function ($event) {
                      _vm.selectedLang = $event
                    },
                    "update:selected-lang": function ($event) {
                      _vm.selectedLang = $event
                    },
                    close: function ($event) {
                      _vm.toEditProp = null
                    },
                  },
                },
                [_vm._t("field-options", null, { field: _vm.toEditProp })],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }